import { NextPage } from 'next'
import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { useRedirection } from 'src/hooks/useRedirection'

import { selectors } from '../redux'
import Router, { routes } from '../routes/Router'

const PublicGuard = (Page: NextPage<any>): FC<any> => {
  return function PublicGuard(props) {
    const isInit = useSelector(selectors.app.isInit)
    const isConnected = useSelector(selectors.auth.isConnected)
    const currentClassifiedSlug = useSelector(
      selectors.classifieds.currentClassifiedSlug
    )
    const redirection = useRedirection()
    const router = useRouter()

    console.log('redirection', redirection)

    useEffect(() => {
      if (isInit && isConnected) {
        if (currentClassifiedSlug) {
          Router.pushRoute(routes.classified, {
            slug: currentClassifiedSlug,
          })
        } else {
          if (redirection.shouldRedirect && redirection.redirectUrl) {
            redirection.setHasRedirected(true)
            router.push(redirection.redirectUrl!)
          } else {
            Router.pushRoute(routes.account)
          }
        }
      }
    }, [isInit, isConnected, currentClassifiedSlug, router, redirection])

    if (!isInit || isConnected) {
      return null
    }

    return <Page {...props} />
  }
}

export default PublicGuard
